// @core/api/endpoints/authz/list_authorization_models.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAuthorizationModelsResponse,
} from '../../../types/authz';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/authz';

/**
 * List authorization models
 * Returns all authorization model versions in reverse chronological order. Supports pagination for browsing model history and allows administrators to view and compare different model versions.
 */
export async function ListAuthorizationModels(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAuthorizationModelsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/models`;
  const requestOptions = options;
  return client.get<ListAuthorizationModelsResponse>(requestPath, { ...requestOptions, params });
}
